(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoDialogController', SSMovimientoEstatusProyectoDialogController);

    SSMovimientoEstatusProyectoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSMovimientoEstatusProyecto', 'SSProyecto'];

    function SSMovimientoEstatusProyectoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSMovimientoEstatusProyecto, SSProyecto) {
        var vm = this;

        vm.sSMovimientoEstatusProyecto = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ssproyectos = SSProyecto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSMovimientoEstatusProyecto.id !== null) {
                SSMovimientoEstatusProyecto.update(vm.sSMovimientoEstatusProyecto, onSaveSuccess, onSaveError);
            } else {
                SSMovimientoEstatusProyecto.save(vm.sSMovimientoEstatusProyecto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSMovimientoEstatusProyectoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaMovimiento = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
